import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const NotificationSettings = ({ settings, onSave }) => {
  const [localSettings, setLocalSettings] = useState(settings);

  const handleToggle = (key) => {
    setLocalSettings(prev => ({
      ...prev,
      [key]: !prev?.[key]
    }));
  };

  const handleSave = () => {
    onSave(localSettings);
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-card p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Configuración de Notificaciones</h3>
          <p className="text-sm text-muted-foreground mt-1">
            Controla cómo te comunicamos con tus clientes
          </p>
        </div>
        <Button variant="default" iconName="Save" onClick={handleSave}>
          Guardar Cambios
        </Button>
      </div>
      <div className="space-y-6">
        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center gap-3 mb-3">
            <Icon name="Bell" size={20} color="var(--color-primary)" />
            <h4 className="text-sm font-semibold text-foreground">Notificaciones de Escaneo</h4>
          </div>
          <div className="space-y-3 ml-8">
            <Checkbox
              label="Notificarme cuando un cliente escanee mi QR"
              description="Recibe alertas instantáneas de cada escaneo"
              checked={localSettings?.scanNotifications}
              onChange={() => handleToggle('scanNotifications')}
            />
            <Checkbox
              label="Enviar resumen diario de escaneos"
              description="Recibe un reporte al final del día"
              checked={localSettings?.dailySummary}
              onChange={() => handleToggle('dailySummary')}
            />
          </div>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center gap-3 mb-3">
            <Icon name="MessageSquare" size={20} color="var(--color-secondary)" />
            <h4 className="text-sm font-semibold text-foreground">Comunicación con Clientes</h4>
          </div>
          <div className="space-y-3 ml-8">
            <Checkbox
              label="Permitir mensajes directos de clientes"
              description="Los clientes pueden contactarte a través de la plataforma"
              checked={localSettings?.directMessages}
              onChange={() => handleToggle('directMessages')}
            />
            <Checkbox
              label="Notificar sobre comentarios en publicaciones"
              description="Recibe alertas cuando comenten tus posts"
              checked={localSettings?.commentNotifications}
              onChange={() => handleToggle('commentNotifications')}
            />
          </div>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center gap-3 mb-3">
            <Icon name="TrendingUp" size={20} color="var(--color-accent)" />
            <h4 className="text-sm font-semibold text-foreground">Promociones y Marketing</h4>
          </div>
          <div className="space-y-3 ml-8">
            <Checkbox
              label="Enviar notificaciones push a clientes"
              description="Promociona ofertas especiales directamente"
              checked={localSettings?.pushNotifications}
              onChange={() => handleToggle('pushNotifications')}
            />
            <div className="bg-card rounded-lg p-3 border border-border">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-foreground">Límite Mensual de Notificaciones</p>
                  <p className="text-xs text-muted-foreground mt-1">
                    Basado en tu plan actual
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-2xl font-bold text-primary">{settings?.notificationLimit}</p>
                  <p className="text-xs text-muted-foreground">por mes</p>
                </div>
              </div>
              <div className="mt-3">
                <div className="flex items-center justify-between text-xs text-muted-foreground mb-1">
                  <span>Usadas: {settings?.notificationsUsed}</span>
                  <span>Restantes: {settings?.notificationLimit - settings?.notificationsUsed}</span>
                </div>
                <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-primary transition-all duration-300"
                    style={{ width: `${(settings?.notificationsUsed / settings?.notificationLimit) * 100}%` }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-primary/5 rounded-lg p-4 border border-primary/20">
          <div className="flex items-start gap-3">
            <Icon name="Info" size={20} color="var(--color-primary)" />
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground mb-2">Información Importante</p>
              <ul className="space-y-1 text-xs text-foreground">
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={12} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                  <span>Las notificaciones push requieren aprobación del cliente</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={12} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                  <span>El límite de notificaciones se renueva el primer día de cada mes</span>
                </li>
                <li className="flex items-start gap-2">
                  <Icon name="Check" size={12} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                  <span>Puedes actualizar tu plan para aumentar el límite de notificaciones</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;